import circularDots from "../../../assets/icons/circulardots.svg";
import React from "react";
import styled, {keyframes, css} from "styled-components";
import {ReactComponent as CloseIcon} from "assets/icons/close-attachment-error.svg";

const ErrorText = styled.div`
  color: #FFFFFF;
  overflow: hidden;
  flex-grow: 1;
  font-size: 9px;
  line-height: 11px;
  left: 40px;
  margin-left: 20px;
  max-height: ${p => p.message !== '' ? '20px' : '0'};
  transition: max-height 0.1s ease-out;
`;

const ErrorMessageContainer = styled.div`
  max-height: ${p => p.message !== '' ? '20px' : '0'};
  height: 20px;
  background: #FB5151;
  position: absolute;
  width: 100%;
  z-index: 9;
  display: flex;
  overflow: hidden;
  align-items: center;
  flex: 1;
  transition: max-height 0.1s ease-out;
  & svg{
    max-height: ${p => p.message !== '' ? '20px' : '0'}
  }
  & ${ErrorText}{
    max-height: ${p => p.message !== '' ? '20px' : '0'}
  }
`;

const AttachmentError = ({ message, setUploadErrorMessage }) => {
    return (
        <ErrorMessageContainer message={message}>
            <ErrorText message={message}>{message}</ErrorText>
            <CloseIcon style={{marginRight: '20px', padding: '5px', cursor: 'pointer'}} onClick={()=>{setUploadErrorMessage('')}} />
        </ErrorMessageContainer>
    );
};

export default AttachmentError;